<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <loading-spinner v-if="isLoading"></loading-spinner>

                <v-card v-else>
                    <card-header :title="$t('title.consent_document_detail')" icon="menu" color="primary"
                        variant="gradient"></card-header>

                    <v-card-text>
                        <v-row>
                            <v-col cols="12" sm="6">
                                <v-text-field v-model="consentDocument.title"
                                    :label="$t('label.consent_document_title')" readonly></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field v-model="consentDocument.document_type_name"
                                    :label="$t('label.consent_document_category')" readonly></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12">
                                <v-textarea v-model="consentDocument.content"
                                    :label="$t('label.consent_document_content')" outlined dense readonly></v-textarea>
                            </v-col>
                        </v-row>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <custom-button :label="$t('button.close')" color="black" size="lg" gradient rounded
                                @click="toConsentDocumentList"></custom-button>
                        </v-card-actions>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import CardHeader from '@/components/cards/CardHeader.vue';
import CustomButton from '@/components/common/buttons/CustomButton.vue';
import { consentDocumentApi } from '@/api/api';

import LoadingSpinner from '@/components/common/Spinners/LoadingSpinner.vue';

export default {
    name: 'ShowConsentDocument',
    components: {
        CardHeader,
        CustomButton,
        LoadingSpinner,
    },
    props: {
        idx: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            consentDocument: {
                title: '',
                consent_document_type_name: '',
                content: '',
            },
            isLoading: false,
        }
    },
    methods: {
        toConsentDocumentList() {
            this.$router.push(`/journals/consent-documents/management`);
        },

        /* ****************************************************************************************
         * API 호출
         * ****************************************************************************************/
        async fetchConsentDocument() {
            this.isLoading = true;
            const params = {
                idx: this.idx,
            }

            try {
                const response = await consentDocumentApi.showConsentDocument(params);

                if (response.status === 200) {
                    this.consentDocument = response.data.response;
                }
            } catch (error) {
                this.notifyVue({ message: this.$t('alert.failed_request'), style: "danger" });
            } finally {
                this.isLoading = false;
            }
        },


        /* ****************************************************************************************
         * 알럿
         * ****************************************************************************************/
        notifyVue({
            vertical = "top",
            horizontal = "right",
            message = "",
            style = "primary",
            icon = "priority_high",
        } = {}) {
            this.$notify({
                timeout: 8000,
                message: message,
                icon: icon,
                type: style,
                horizontalAlign: horizontal,
                verticalAlign: vertical,
            });
        },
    },
    mounted() {
        this.fetchConsentDocument();
    }
}
</script>